module.exports = __webpack_public_path__ + "static/media/score_heatmap_3.7f128996.png";